import React, { useState, useEffect } from "react";
import { Image, Anchor } from "@mantine/core";
import { getPresentationParamsForOrigin } from "../getPresentationParamsForOrigin.ts";

const PLAY_STORE_URL = getPresentationParamsForOrigin().apps?.android;

// Official Google Play badge (German version)
// See: https://play.google.com/intl/en_us/badges/
const GOOGLE_PLAY_BADGE_URL =
  "https://play.google.com/intl/en_us/badges/static/images/badges/de_badge_web_generic.png";

function isAndroid(): boolean {
  if (typeof navigator === "undefined") return false;
  return /android/i.test(navigator.userAgent);
}

function isInstalledAsPWA(): boolean {
  if (typeof window === "undefined") return false;

  // Check if running in standalone mode (installed as PWA)
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  // iOS Safari specific check
  const isIOSStandalone =
    (navigator as { standalone?: boolean }).standalone === true;

  return isStandalone || isIOSStandalone;
}

interface GooglePlayBadgeProps {
  height?: number;
}

export const GooglePlayBadge: React.FC<GooglePlayBadgeProps> = ({
  height = 36,
}) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const android = isAndroid();
    const installed = isInstalledAsPWA();

    setShouldShow(android && !installed);
  }, []);

  if (!PLAY_STORE_URL) {
    return null;
  }

  if (!shouldShow) {
    return null;
  }

  return (
    <Anchor href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
      <Image
        src={GOOGLE_PLAY_BADGE_URL}
        alt="Jetzt bei Google Play"
        h={height}
        w="auto"
        fit="contain"
      />
    </Anchor>
  );
};
